import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import PlaceBetCalculations from './place-bet-calculations.js';

const { UIView } = MojitoCore.Presentation;

/**
 * View for displaying bet related calculations.
 *
 * @class PlaceBetCalculations
 * @memberof Mojito.Modules.BetslipView
 */

/**
 * PlaceBetCalculations prop types.
 *
 * @property {Mojito.Services.Betslip.types.Calculation} calculation - Betslip calculation.
 * @property {boolean} [calculationsHasAccaBoost = false] - Indicates whether the calculations should be displayed as boosted.
 * @property {string} [currencyCode] - Currency code to use in betslip.
 * @property {boolean} [isSuspended = false] - Defines whether the calculations are suspended.
 * @property {object} [bonusInfo = {}] - Additional information about the bonus.
 * @memberof Mojito.Modules.BetslipView.PlaceBetCalculations
 */
const propTypes = {
    calculation: PropTypes.object.isRequired,
    calculationsHasAccaBoost: PropTypes.bool,
    currencyCode: PropTypes.string,
    isSuspended: PropTypes.bool,
    bonusInfo: PropTypes.object,
};

const defaultProps = {
    isSuspended: false,
    calculationsHasAccaBoost: false,
    bonusInfo: {},
};

export default UIView('PlaceBetCalculations', PlaceBetCalculations, propTypes, defaultProps);
